import { flexRender, Table as ReactTable, Row } from '@tanstack/react-table';
import Table, { TableBody, TableHeader } from '@ingka/table';
import SSRIcon from '@ingka/ssr-icon';
import ChevronDown from '@ingka/ssr-icon/paths/chevron-down';
import ChevronUp from '@ingka/ssr-icon/paths/chevron-up';

import styles from './index.module.css';

type TableProps<T> = {
  table: ReactTable<T>;
  onClickRow?: (row: Row<T>) => void;
};

export function SkapaTable<T>({ table, onClickRow }: TableProps<T>) {
  return (
    <div className="overflow-x-auto overflow-y-hidden w-full">
      <Table className="w-full mt-2 mb-2" fullWidth>
        <TableHeader>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <th
                    key={header.id}
                    colSpan={header.colSpan}
                    className={`${
                      header.column.getCanSort() ? 'cursor-pointer' : ''
                    } ${header.column.columnDef.meta?.headerClassName || ''}`}
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    {header.isPlaceholder ? null : (
                      <div className="flex items-center">
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                        {header.column.getCanSort() && (
                          <div className="flex flex-col ml-[10px] h-6">
                            <SSRIcon
                              paths={ChevronUp}
                              className={
                                styles[
                                  header.column.getIsSorted() === 'asc'
                                    ? 'fill--selected'
                                    : 'fill'
                                ]
                              }
                            />
                            <SSRIcon
                              paths={ChevronDown}
                              className={
                                styles[
                                  header.column.getIsSorted() === 'desc'
                                    ? 'fill--selected'
                                    : 'fill'
                                ]
                              }
                            />
                          </div>
                        )}
                        {/* header.column.getIsSorted() */}
                      </div>
                    )}
                  </th>
                );
              })}
            </tr>
          ))}
        </TableHeader>

        <TableBody className="text-sm">
          {table.getRowModel().rows.map((row) => {
            return (
              <tr
                key={row.id}
                className={`${
                  onClickRow ? 'hover:bg-ikea-grey hover:cursor-pointer' : ''
                } ${row.getIsSelected() ? 'bg-ikea-grey' : ''}`}
                onClick={() => onClickRow && onClickRow(row)}
              >
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
